import { SxProps } from '@mui/material';

export const ToggleSx: SxProps = {
  width: { xs: '100px', sm: '200px', md: '300px' },
};
